var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex mb-3"},[_c('data-loader',{staticClass:"mr-4",attrs:{"custom-loading-trigger":_vm.isLoading}}),(!_vm.isLoading)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_c('h3',[_vm._v(_vm._s(_vm.$t('global.loading-data')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }